import { inject, Injectable } from '@angular/core';
import { ApiClient } from './api-client';
import { SHARED_CONFIG } from '../../../environments/shared-config.token';
import { Observable, switchMap } from 'rxjs';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { FileUtils } from '../../shared';
import { Attachment } from '../models/attachment/attachment';
import * as buffer from 'buffer';

@Injectable({
  providedIn: 'root',
})
export class AttachmentApi {
  private apiClient = inject(ApiClient);
  private config = inject(SHARED_CONFIG);

  public uploadAttachmentFile(attachment: Attachment, file: File): Observable<HttpResponse<unknown>> {
    const fileType = file.type;
    const headers = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': fileType,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Encoding': 'base64',
      'x-amz-meta-attachmentid': attachment.id ?? '',
    });
    return FileUtils.fileToB64(file).pipe(
      switchMap(fileUrl => {
        const replacementString = `data:${fileType};base64,`;
        const newFileName = fileUrl.replace(replacementString, '');
        const buff = buffer.Buffer.from(newFileName, 'base64');
        const blob = new Blob([new Uint8Array(buff)]);
        return this.apiClient.putAssetToS3(attachment.originalLink ?? '', blob, headers);
      }),
    );
  }
}
